// src/utils/colorRules.js

// --- Centralized brand color definitions ---
export const BRAND_COLORS = {
  success: "#04aa00", // vihreä
  warning: "#d0c407", // keltainen
  danger:  "#ba3b46", // punainen
  info:    "#007bff", // sininen (example for future use)
  neutral: "#000000", // fallback
};

// --- Rule registry (easy to extend) ---
export const COLOR_RULES = [
    {
        key: "KL",
        regex: /KL\s*([1-5])/gi,
        getColor: (match) => {
        const level = Number(match[1]);
        switch (true) {
            case level >= 4:
            return BRAND_COLORS.success;
            case level === 3:
            return BRAND_COLORS.warning;
            case level <= 2:
            return BRAND_COLORS.danger;
            default:
            return BRAND_COLORS.neutral;
        }
        },
    },
    {
        key: "VAARA",
        regex: /\bVAARA\b/gi,
        getColor: () => BRAND_COLORS.danger,
    },
    {
        key: "HUOM",
        regex: /\bHUOM\b/gi,
        getColor: () => BRAND_COLORS.warning,
    },

    // ✅ New risk phrases
    {
        key: "MATALA_RISKI",
        regex: /√\s*MATALA\s+RISKI/gi,
        getColor: () => BRAND_COLORS.success,
    },
    {
        key: "KESKITASON_RISKI",
        regex: /√\s*KESKITASON\s+RISKI/gi,
        getColor: () => BRAND_COLORS.warning,
    },
    {
        key: "KORKEA_RISKI",
        regex: /√\s*KORKEA\s+RISKI/gi,
        getColor: () => BRAND_COLORS.danger,
    },
];

// --- Helper to find color for a full string (simple use) ---
export function getColorForText(text) {
  if (!text) return null;
  for (const rule of COLOR_RULES) {
    const match = text.match(rule.regex);
    if (match) return rule.getColor(match);
  }
  return null;
}

// --- 💪 Safe split function for pdfmake ---
export function splitTextByColorRules(text) {
  if (!text) return [{ text: "—" }];

  const matches = [];

  // Collect all rule matches safely
  for (const rule of COLOR_RULES) {
    let match;
    while ((match = rule.regex.exec(text)) !== null) {
      matches.push({
        index: match.index,
        length: match[0].length,
        color: rule.getColor(match),
        text: match[0],
      });
    }
    rule.regex.lastIndex = 0; // reset for reuse
  }

  if (!matches.length) return [{ text }];

  // Sort by position in text
  matches.sort((a, b) => a.index - b.index);

  const parts = [];
  let lastIndex = 0;

  for (const m of matches) {
    if (m.index > lastIndex) {
      const before = text.substring(lastIndex, m.index);
      if (before) parts.push({ text: before });
    }

    // Add the colored section
    if (m.text) {
      parts.push({
        text: m.text,
        bold: true,
        color: m.color || BRAND_COLORS.neutral,
      });
    }

    lastIndex = m.index + m.length;
  }

  // Add any trailing text
  if (lastIndex < text.length) {
    const trailing = text.substring(lastIndex);
    if (trailing) parts.push({ text: trailing });
  }

  // Defensive guard: ensure array always valid
  const validParts = parts.filter(
    (p) => p && typeof p.text === "string" && p.text.length > 0
  );
  if (!validParts.length) return [{ text }];

  return validParts;
}
